import { createAsyncThunk } from "@reduxjs/toolkit";
import {  postNomineeNotOpted } from "../../../helpers/fakebackend_helper";

export const re_kyc_nomineeNotOptedThunk = createAsyncThunk(
  "re_kyc_nomineeNotOptedThunk",
  async ({  token }, { rejectWithValue }) => {
    try {
      const response = await postNomineeNotOpted( token);
      return response;
    } catch (error) {
      // Properly pass the error structure to the reducer
      return rejectWithValue({
        code: error.data?.code || error.code,
        message: error.message,
        data: error.data,
      });
    }
  }
);
